import React from 'react';
import HeroSection from '../components/HeroSection';
import ProblemSolution from '../components/ProblemSolution';
import HowItWorks from '../components/HowItWorks';
import WhyChoose from '../components/WhyChoose';
import Testimonials from '../components/Testimonials';
import PricingCalculator from '../components/PricingCalculator';
import FAQSection from '../components/FAQSection';
import LeadCapture from '../components/LeadCapture';
import WhatsAppButton from '../components/WhatsAppButton';
import '../index.css'; // Ensure global styles are loaded

const HomePage = () => (
  <div>
    {/* Animated Cashback Banner */}
    <div className="relative overflow-x-hidden bg-accent text-white font-bold text-base md:text-lg py-2">
      <div className="animate-marquee whitespace-nowrap">
        Flat 10% cashback on your first order
      </div>
    </div>
    <HeroSection />
    <ProblemSolution />
    <HowItWorks />
    <WhyChoose />
    <Testimonials />
    <PricingCalculator />
    <FAQSection />
    <LeadCapture />
    <WhatsAppButton />
  </div>
);

export default HomePage; 